import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import Reveal from '../../../shared/Reveal/Reveal';
import { useSolutionsOurExpertiseContent } from '../../../../hooks/useSolutionsOurExpertiseContent';
import './OurExpertise.css';

const OurExpertise = () => {
  const { content, isLoading } = useSolutionsOurExpertiseContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, cards } = content;

  return (
    <section className="our-expertise">
      <div className="our-expertise__inner">
        <Reveal>
          <h2 className="our-expertise__title">{title}</h2>
        </Reveal>

        <div className="our-expertise__grid">
          {cards.map(({ category, title: cardTitle, cardDescription, cta, slug }, index) => (
            <Reveal key={`${slug}-${index}`} delay={index * 70}>
              <article className="our-expertise__card">
                <div className="our-expertise__card-top">
                  <p className="our-expertise__card-category">{category}</p>
                  <h3 className="our-expertise__card-title">{cardTitle}</h3>
                </div>

                <div className="our-expertise__card-bottom">
                  <p className="our-expertise__card-text">{cardDescription}</p>
                  <Link to={slug} className="our-expertise__card-link">
                    {cta}
                    <HiArrowRight
                      className="our-expertise__card-link-icon"
                      aria-hidden="true"
                    />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurExpertise;
